export default "__VITE_ASSET__Cjf45Yl0__"